import { render, staticRenderFns } from "./ChpContentDesktop.vue?vue&type=template&id=ea76ed38&"
import script from "./ChpContentDesktop.vue?vue&type=script&lang=js&"
export * from "./ChpContentDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ChpContentDesktop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports